import { Locale } from '@kamernet/core/Intl/types';

export const SupportLink = {
  [Locale.en]:
    'https://share-eu1.hsforms.com/13yVmu8sQT4q1OTHOnmhQbwfffjg?__hstc=254766423.4b68065c1c46d2e84707f9cc3e1114e1.1659625661981.1687270568808.1687423409062.155&__hssc=254766423.3.1687423409062&__hsfp=4252290568',
  [Locale.nl]:
    'https://share-eu1.hsforms.com/1sdymWd1yTcOW7EQYxULb6gfffjg?__hstc=254766423.4b68065c1c46d2e84707f9cc3e1114e1.1659625661981.1687270568808.1687423409062.155&__hssc=254766423.1.1687423409062&__hsfp=4252290568',
};
